import { lazy } from 'react';

export const News = lazy(() => import('./News.component'));
